export enum PersonnelStatus {
	ACTIVE = "Active",
	DEACTIVATED = "Deactivated"
}

export const PERSONNEL_STATUS_LABELS: Record<PersonnelStatus, string> = {
	[PersonnelStatus.ACTIVE]: "Active",
	[PersonnelStatus.DEACTIVATED]: "Deactivated"
};

// Filter options for personnel status (includes "All personnel" option)
// DEACTIVATED uses "Deactivated" as the URL-visible value to match the display label.
// Use PERSONNEL_STATUS_API_VALUE to map filter option values back to API status strings.
export const PERSONNEL_STATUS_FILTER_OPTIONS = {
	ALL_PERSONNEL: "All personnel",
	ACTIVE: PersonnelStatus.ACTIVE,
	DEACTIVATED: PersonnelStatus.DEACTIVATED,
	PENDING_APPROVAL: "Pending Approval"
} as const;

// Maps filter option values to the API-returned status strings for comparison
export const PERSONNEL_STATUS_API_VALUE: Partial<Record<string, string>> = {
	[PersonnelStatus.ACTIVE]: PersonnelStatus.ACTIVE,
	[PersonnelStatus.DEACTIVATED]: PersonnelStatus.DEACTIVATED
} as const;

export type PersonnelStatusFilterOption =
	(typeof PERSONNEL_STATUS_FILTER_OPTIONS)[keyof typeof PERSONNEL_STATUS_FILTER_OPTIONS];
